import { createComponent } from '@lit-labs/react';
import React from 'react';
import { CustomValidity, Replacement } from '.';

export class BaseInputDS extends HTMLElement {
  required?: boolean;
  maxLength?: string;
  class?: string;
  value: unknown;
  label?: string;
  mobileType?: string;
  replacement?: string | Replacement[];
  customValidityPattern?: string | CustomValidity[];
  placeholder?: string;
  constructor() {
    super();
  }
}

export const BaseInput = createComponent(React, 'base-input', BaseInputDS, {
  onInputChange: 'input-changed',
  onFocus: 'element-focused',
  onLetterChanged: 'letter-changed',
  onListBlur: 'element-blured',
});
